
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1736911574825",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "979",
    "width": "32",
    "height": "32"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M598.2 928.5c-6.6 0-13-2.2-18.3-6.2l-270.7-208H182c-45.7 0-82.9-37.2-82.9-82.9V395.2c0-45.7 37.2-82.9 82.9-82.9h127.1l270.7-208c5.2-4 11.7-6.2 18.3-6.2 45.7 0 82.9 37.2 82.9 82.9v664.6c0.1 45.7-37.1 82.9-82.8 82.9zM182 372.2c-12.6 0-22.9 10.3-22.9 22.9v236.1c0 12.6 10.3 22.9 22.9 22.9h137.3c6.6 0 13 2.2 18.3 6.2l268.8 206.5c8.6-3.3 14.7-11.7 14.7-21.4V180.9c0-9.8-6.1-18.1-14.7-21.4L337.6 366c-5.2 4-11.7 6.2-18.3 6.2H182z",
        "fill": "#515151",
        "p-id": "980"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M846.6 731.3c-4.8 0-9.7-1.2-14.3-3.6-14.6-7.9-20-26.1-12-40.7 29-53.4 44.4-114 44.4-175.2 0-62-15.7-123.4-45.5-177.3-8-14.5-2.7-32.8 11.8-40.8s32.8-2.7 40.8 11.8c34.7 62.8 53 134.1 53 206.3 0 71.2-17.9 141.7-51.6 203.9-5.6 10-15.9 15.6-26.6 15.6z",
        "fill": "#515151",
        "p-id": "981"
      }
    }
  ]
})
    }
  